var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.usageStrategy)?_c('el-tag',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"usage",attrs:{"type":_vm.availableCredit.executionsBalance === 0 ? 'danger' : 'warning'}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.usageString)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }